<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               @on-load="onLoad">

    </avue-crud>
  </basic-container>
</template>

<script>
  import { add, getDetail, getList, remove, update } from '@/api/v4ward/pay/paymerchant';
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        form: {},
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        selectionList: [],
        option: {
          height: 'auto',
          calcHeight: 30,
          tip: false,
          searchShow: true,
          searchMenuSpan: 6,
          border: true,
          index: true,
          indexLabel:'序号',
          viewBtn: true,
          selection: false,
          dialogClickModal: false,
          column: [
            {
              label: '平台商户号',
              prop: 'wpMchId',
              search:true,
              searchLabelWidth: 100,
              labelWidth: 120,
              editDisabled: true,
              addDisplay:false,
              rules: [{
                required: true,
                message: '请输入平台商户号',
                trigger: 'change',
              }],
            },
            {
              label: '平台商户名称',
              prop: 'wpMchName',
              search:true,
              searchLabelWidth: 100,
              labelWidth: 120,
              maxlength:50,
              editDisabled: true,
              showWordLimit:true,
              rules: [{
                required: true,
                message: '请输入平台商户名称',
                trigger: 'change',
              }],
            },
            {
              label: '联系人',
              prop: 'contact',
              maxlength:10,
              labelWidth: 120,
              showWordLimit:true,
              rules: [{
                required: true,
                message: '请输入联系人',
                trigger: 'change',
              }],
            },
            {
              label: '联系电话',
              prop: 'phone',
              maxlength:20,
              labelWidth: 120,
              showWordLimit:true,
              rules: [{
                required: true,
                message: '请输入联系电话',
                trigger: 'change',
              },
                {
                  required: true,
                  pattern: this.$validation.phone,
                  message: '请输入正确的联系电话',
                  trigger: 'change',
                },],
            },
            {
              label: '授权部门',
              prop: 'deptId',
              editDisabled: true,
              type: 'tree',
              labelWidth: 120,
              dicUrl: '/api/base/deptproperty/tree',
              props: {
                labelText: '标题',
                label: 'title',
                value: 'value',
                children: 'children', },
              rules: [{
                required: true,
                message: '请选择授权部门',
                trigger: 'change',
              }],
            },
          ],
        },
        data: [],
      };
    },
    computed: {
      ...mapGetters(['permission']),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.paymerchant_add, false),
          viewBtn: this.vaildData(this.permission.paymerchant_view, false),
          delBtn: this.vaildData(this.permission.paymerchant_delete, false),
          editBtn: this.vaildData(this.permission.paymerchant_edit, false),
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(',');
      },
    },
    methods: {
      rowSave(row, done, loading) {
        row.deptName = row.$deptId;
        console.log("保存商户信息："+JSON.stringify(row));
        add(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowUpdate(row, index, done, loading) {
        update(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDel(row) {
        this.$confirm('确定将选择数据删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return remove(row);
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning('请选择至少一条数据');
          return;
        }
        this.$confirm('确定将选择数据删除?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            return remove({ ids: this.ids });
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (['edit', 'view'].includes(type)) {
          getDetail({ id: this.form.id }).then(({ data }) => {
            this.form = data;
          });
        }
        done();
      },
      searchReset() {
        this.query = {};
        this.onLoad();
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        getList(
          Object.assign({ current: page.currentPage, size: page.pageSize }, this.query),
        ).then(({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      },
    },
  };
</script>

<style>
</style>
